import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Person4Icon from '@mui/icons-material/Person4';
import PersonIcon from "@mui/icons-material/Person";
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaMoneyBillWave, FaBriefcase, FaRegClock, FaBuilding } from "react-icons/fa";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

const LoginForm = () => {
    const history = useHistory();
    const { isAuthenticated, login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    // const [companyId, setCompanyId] = useState('');
    //const [branchId, setBranchId] = useState('');
    const location = useLocation();

    const branchId = 1;
    const companyId = 1;

    useEffect(() => {
        setIsAnimating(true);
    }, []);



    const handleLogin = async () => {
        try {

            const jwtToken = await performLogin();
            const responseData = jwtDecode(jwtToken);
            const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
            const permissions = Object.keys(responseData).filter(
                (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
            );

            let isSuper = false;
            if (responseData.isSuperAdmin.toLowerCase() === "true") {
                isSuper = true;
            }

            if (isSuper == false) {
                const parsedCompanyId = parseInt(responseData.companyId, 10);

                if (parsedCompanyId === companyId) {
                    login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                    const redirectParam = new URLSearchParams(location.search).get("redirect");
                    const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                    history.replace(redirectPath);
                }
                else {
                    toast.error('Invalid User !', {
                        position: "top-center",
                    });
                }
            }
            else {
                login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                const redirectParam = new URLSearchParams(location.search).get("redirect");
                const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                history.replace(redirectPath);
            }


        } catch (error) {
            toast.error('Login failed', {
                position: "top-center",
            });
        }
    };

    const performLogin = async () => {
        const loginData = {
            UserName: username,
            Password: password,
            CompanyId: companyId,
            BranchId: branchId
        };

        const response = await postLogin('LoginApi', loginData);

        if (response.responseCode === '1111') {
            const jwtToken = response.response_data.token;

            return jwtToken;
        } else {
            throw new Error(response.Message);
        }
    };


    if (isAuthenticated) {
        return <App />;
    }


    //     return (
    //         <div
    //             style={{
    //                 display: "flex",
    //                 justifyContent: "center",
    //                 alignItems: "center",
    //                 minHeight: "100vh",
    //                 background: "linear-gradient(135deg, #0a1f27, #144552)", // deep teal gradient
    //                 fontFamily: "'Arial', sans-serif",
    //             }}
    //         >
    //             <div
    //                 style={{
    //                     width: "100%",
    //                     maxWidth: "420px",
    //                     padding: "40px",
    //                     borderRadius: "14px",
    //                     background: "#185a6d", 
    //                     boxShadow: "0 12px 32px rgba(0, 0, 0, 0.5)",
    //                     textAlign: "center",
    //                 }}
    //             >

    //                 <AutoStoriesIcon style={{ fontSize: "55px", marginBottom: "20px", color: "#ff6b6b" }} />

    //                 <h3 style={{ marginBottom: "10px", fontFamily: "'Cursive'", color: "#fff", fontSize: "22px" }}>
    //                     Payroll Desk
    //                 </h3>
    //                 <p style={{ marginBottom: "30px", color: "#cfd8dc", fontSize: "12px" }}>
    //                     Enter your payroll credentials to access your account
    //                 </p>

    //                 <form
    //                     onSubmit={(e) => {
    //                         e.preventDefault();
    //                         handleLogin();
    //                     }}
    //                 >

    //                     <div style={{ position: "relative", marginBottom: "22px" }}>
    //                         <FaUser
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 left: "12px",
    //                                 transform: "translateY(-50%)",
    //                                 color: "#b0bec5",
    //                             }}
    //                         />
    //                         <input
    //                             type="text"
    //                             placeholder="User Name"
    //                             value={username}
    //                             onChange={(e) => setUsername(e.target.value)}
    //                             style={{
    //                                 width: "100%",
    //                                 padding: "14px 12px 14px 42px",
    //                                 borderRadius: "10px",
    //                                 border: "1px solid #4fb3bf",
    //                                 background: "#1c758a",
    //                                 color: "#fff",
    //                                 outline: "none",
    //                                 fontSize: "15px",
    //                                 transition: "all 0.3s ease",
    //                             }}
    //                         />
    //                     </div>


    //                     <div style={{ position: "relative", marginBottom: "25px" }}>
    //                         <FaLock
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 left: "12px",
    //                                 transform: "translateY(-50%)",
    //                                 color: "#b0bec5",
    //                             }}
    //                         />
    //                         <input
    //                             type={showPassword ? "text" : "password"}
    //                             placeholder="Password"
    //                             value={password}
    //                             onChange={(e) => setPassword(e.target.value)}
    //                             style={{
    //                                 width: "100%",
    //                                 padding: "14px 42px 14px 42px",
    //                                 borderRadius: "10px",
    //                                 border: "1px solid #4fb3bf",
    //                                 background: "#1c758a",
    //                                 color: "#fff",
    //                                 outline: "none",
    //                                 fontSize: "15px",
    //                                 transition: "all 0.3s ease",
    //                             }}
    //                         />
    //                         <div
    //                             onClick={() => setShowPassword((prev) => !prev)}
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 right: "12px",
    //                                 transform: "translateY(-50%)",
    //                                 color: "#b0bec5",
    //                                 cursor: "pointer",
    //                             }}
    //                         >
    //                             {showPassword ? <FaEyeSlash /> : <FaEye />}
    //                         </div>
    //                     </div>


    //                     <button
    //                         type="submit"
    //                         style={{
    //                             width: "100%",
    //                             padding: "14px",
    //                             borderRadius: "10px",
    //                             border: "none",
    //                             background: "linear-gradient(90deg, #ff6b6b, #ff8787)",
    //                             color: "#fff",
    //                             fontWeight: "bold",
    //                             cursor: "pointer",
    //                             fontSize: "15px",
    //                             transition: "all 0.3s ease",
    //                         }}
    //                         onMouseEnter={(e) => {
    //                             e.target.style.background = "#fff";
    //                             e.target.style.color = "#185a6d";
    //                         }}
    //                         onMouseLeave={(e) => {
    //                             e.target.style.background = "linear-gradient(90deg, #ff6b6b, #ff8787)";
    //                             e.target.style.color = "#fff";
    //                         }}
    //                     >
    //                         Login
    //                     </button>
    //                 </form>
    //             </div>
    //         </div>


    //     );
    // };

    return (
        <>
            {/* Inline animations */}
            <style>
                {`
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          @keyframes pulse {
            0% { box-shadow: 0 0 10px #ff6b6b; }
            50% { box-shadow: 0 0 25px #ff8787; }
            100% { box-shadow: 0 0 10px #ff6b6b; }
          }
          @keyframes slideIn {
            from { transform: translate(-20px, -50%); opacity: 0; }
            to { transform: translate(0, -50%); opacity: 1; }
          }
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes iconFloat {
            0% { transform: translateY(0) rotate(0deg); opacity: 0.8; }
            50% { transform: translateY(-30px) rotate(20deg); opacity: 1; }
            100% { transform: translateY(0) rotate(0deg); opacity: 0.8; }
          }
        `}
            </style>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    background: "linear-gradient(135deg, #0a1f27, #144552)",
                    fontFamily: "'Arial', sans-serif",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* 🌟 Floating background payroll icons */}
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 1,
                        pointerEvents: "none",
                    }}
                >
                    {[...Array(8)].map((_, i) => {
                        const icons = [
                            <FaMoneyBillWave />,
                            <FaBriefcase />,
                            <FaRegClock />,
                            <FaBuilding />,
                        ];
                        const Icon = icons[i % icons.length];

                        const randomX = Math.random() * 90; // horizontal position
                        const randomDelay = Math.random() * 5;
                        const randomSize = 25 + Math.random() * 15;

                        return (
                            <div
                                key={i}
                                style={{
                                    position: "absolute",
                                    top: `${Math.random() * 100}%`,
                                    left: `${randomX}%`,
                                    fontSize: `${randomSize}px`,
                                    color: "rgba(255,255,255,0.1)",
                                    animation: `iconFloat 6s ease-in-out ${randomDelay}s infinite`,
                                }}
                            >
                                {Icon}
                            </div>
                        );
                    })}
                </div>

                {/* 🧾 Login container (unchanged) */}
                <div
                    style={{
                        width: "100%",
                        maxWidth: "420px",
                        padding: "40px",
                        borderRadius: "14px",
                        background: "#185a6d",
                        boxShadow: "0 12px 32px rgba(0, 0, 0, 0.5)",
                        textAlign: "center",
                        animation: "fadeInUp 0.8s ease",
                        zIndex: 2,
                    }}
                >
                    <AutoStoriesIcon
                        style={{
                            fontSize: "25px",
                            marginBottom: "20px",
                            color: "white",
                            transformOrigin: "center",
                        }}
                    />

                    <h3
                        style={{
                            marginBottom: "10px",
                            fontFamily: "'Cursive'",
                            color: "#fff",
                            fontSize: "22px",
                        }}
                    >
                        Payroll Desk
                    </h3>
                    <p
                        style={{
                            marginBottom: "30px",
                            color: "#cfd8dc",
                            fontSize: "12px",
                        }}
                    >
                        Enter your payroll credentials to access your account
                    </p>

                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleLogin();
                        }}
                    >
                        {/* Username */}
                        <div style={{ position: "relative", marginBottom: "22px" }}>
                            <FaUser
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "12px",
                                    transform: "translateY(-50%)",
                                    color: "#b0bec5",
                                    animation: "slideIn 0.8s ease",
                                }}
                            />
                            <input
                                type="text"
                                placeholder="User Name"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "14px 12px 14px 42px",
                                    borderRadius: "10px",
                                    border: "1px solid #4fb3bf",
                                    background: "#1c758a",
                                    color: "#fff",
                                    outline: "none",
                                    fontSize: "15px",
                                    transition: "all 0.3s ease",
                                }}
                            />
                        </div>

                        {/* Password */}
                        <div style={{ position: "relative", marginBottom: "25px" }}>
                            <FaLock
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "12px",
                                    transform: "translateY(-50%)",
                                    color: "#b0bec5",
                                    animation: "slideIn 1s ease",
                                }}
                            />
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "14px 42px 14px 42px",
                                    borderRadius: "10px",
                                    border: "1px solid #4fb3bf",
                                    background: "#1c758a",
                                    color: "#fff",
                                    outline: "none",
                                    fontSize: "15px",
                                    transition: "all 0.3s ease",
                                }}
                            />
                            <div
                                onClick={() => setShowPassword((prev) => !prev)}
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "12px",
                                    transform: "translateY(-50%)",
                                    color: "#b0bec5",
                                    cursor: "pointer",
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>

                        {/* Login Button with Pulse */}
                        <button
                            type="submit"
                            style={{
                                width: "100%",
                                padding: "14px",
                                borderRadius: "10px",
                                border: "none",
                                background: "linear-gradient(90deg, #ff6b6b, #ff8787)",
                                color: "#fff",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontSize: "15px",
                                transition: "all 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = "#fff";
                                e.target.style.color = "#185a6d";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = "linear-gradient(90deg, #ff6b6b, #ff8787)";
                                e.target.style.color = "#fff";
                            }}
                        >
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}
export default LoginForm;
